import { createContext, useContext } from 'react';

const SaleOrderContext = createContext();

SaleOrderContext.displayName = 'SaleOrderContext';

const useSaleOrder = () => useContext(SaleOrderContext);

export { SaleOrderContext, useSaleOrder };
